/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import Default from './Default';
import DetailsSectionAU from './DetailSectionAU';
import DetailsSectionMY from './DetailSectionMY';
import DetailsSectionPH from './DetailSectionPH';
import DetailsAlFuttaim from './DetailsAlFuttaim';
import { CustomerInformation } from '../../interfaces/Cart';
import DetailsAlSulaiman from './DetailsAlSulaiman';

/* globals CSS_CONFIG */

const Index: React.FC<CustomerInformation> = (props): JSX.Element => {
  const { addressFieldInfo } = props;
  const addressFieldInfoTransformed = Array.isArray(addressFieldInfo)
    ? addressFieldInfo.filter(Boolean).join(' ')
    : addressFieldInfo;
  const updatedProps = {
    ...props,
    addressFieldInfo: addressFieldInfoTransformed,
  };

  switch (CSS_CONFIG.COUNTRY) {
    case 'au':
    case 'nz':
      return <DetailsSectionAU {...updatedProps} />;
    case 'my':
      return <DetailsSectionMY {...updatedProps} />;
    case 'ph':
      return <DetailsSectionPH {...props} />;
    case 'ae':
    case 'qa':
    case 'om':
    case 'kw':
    case 'eg':
      return <DetailsAlFuttaim {...updatedProps} />;
    case 'bh':
    case 'sa':
      return <DetailsAlSulaiman {...props} />;
    default:
      return <Default {...updatedProps} />;
  }
};
export default Index;
